import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { IdentityService } from "app/services/authentication/identity.service";
import { LocalizationService } from "app/services/localization/localization.service";


@Pipe({
  name: 'distanceDescription',
  pure: false,
})
export class DistanceDescriptionPipe implements PipeTransform {
  constructor(
    private _localizationService: LocalizationService,
    private _translateService: TranslateService,
    private _identityService: IdentityService
  ) {}

  transform(value: string, shortDescription?: boolean): string {
    if (!value) {
      return;
    }
    const countryCode = this._identityService.countryCode;
    // Metric as default
    if (
      this._localizationService.localeData &&
      countryCode != 'US'
    ) {
      return value;
    } else {
      if (!this._localizationService.localeData) {
        return value;
      }

      let kmsMask = new RegExp(
        shortDescription
          ? 'km'
          : this._translateService.instant('length_unit.kms.name'),
        'ig'
      );
      let mtsMask = new RegExp(shortDescription ? 'mt' : 'metros', 'ig');
      let milesTranslation = this._translateService.instant(
        shortDescription ? 'length_unit.miles.abbr' : 'length_unit.miles.name'
      )
      value = value.replace(
        kmsMask,
        milesTranslation
      );
      let finalValue = value.replace(
        mtsMask,
        this._translateService.instant(
          shortDescription ? 'length_unit.feet.abbr' : 'Feet'
        )
      );
      if(this._translateService.currentLang != "en-us" && finalValue.includes(milesTranslation)){
        let includedWordMask = new RegExp(
          this._translateService.instant('included-plural-m'),
          'ig'
        )
        let unlimitedWordMask = new RegExp(
          this._translateService.instant('unlimited-plural-m'),
          'ig'
        )

        return finalValue.replace(
          includedWordMask,
          this._translateService.instant('included-plural-f')
        ).replace(
          unlimitedWordMask,
          this._translateService.instant('unlimited-plural-f')
        )
      }

      return finalValue;
    }
  }
}
